import React, { Fragment, Component } from "react";
import { Button, Row, Col, Form, InputGroup, Container } from "react-bootstrap";
import TableReceptionistsList from "./TableReceptionistsList";
import LoadingProgressBar from "../../spinners/LoadingProgressBar";
import "react-widgets/dist/css/react-widgets.css";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser, faLongArrowAltLeft, faLongArrowAltRight, faSync } from "@fortawesome/free-solid-svg-icons";
import NoPermission from "../../other/NoPermission";
import RowsDropdown from "../../forms/dropdowns/RowsDropdown";

class ReceptionistsList extends Component {
    state = {
        showNOR: this.props.numberOfRecords,
        displayNOR: this.props.numberOfRecords,
        receptionistsList: [],
        originalReceptionists: [],
        searchedPhrase: "",
        loading: true,
        noPermission: false,
    };

    handleSearch = (e) => {
        const searchedPhrase = e.target.value.toLowerCase();
        const { originalReceptionists } = this.state;
        this.setState({ searchedPhrase: searchedPhrase });
        if (searchedPhrase !== "") {
            let filteredReceptionists = originalReceptionists;
            //console.log(filteredReceptionists)
            filteredReceptionists = filteredReceptionists.filter(
                (el) =>
                    el.user_surname.toString().toLowerCase().includes(searchedPhrase) ||
                    el.user_name.toString().toLowerCase().includes(searchedPhrase) ||
                    (el.user_nickname && el.user_nickname.toString().toLowerCase().includes(searchedPhrase)) //el.receptionist_nickname może być nullem
            );
            this.setState({ receptionistsList: filteredReceptionists });
        } else {
            this.setState({ receptionistsList: originalReceptionists });
        }
    };

    handleDownloadData = () => {
        this.props.onResizeWindow("tableNotLoaded");
        this.setState({ loading: true });
        this.getReceptionistList();
    };

    getReceptionistList = async () => {
        const { fetchURL, onShowAlert, t } = this.props;
        try {
            const response = await fetch(`${fetchURL}/receptionists-list`, {
                credentials: "include",
                method: "POST",
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const receptionistsList = fetchedData.receptionistsList;

                        this.setState({
                            receptionistsList: receptionistsList,
                            originalReceptionists: receptionistsList,
                            loading: false,
                        });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
        }
    };

    componentDidMount() {
        this.getReceptionistList();
        const { onResizeWindow } = this.props;
        onResizeWindow("tableNotLoaded");
        $(window).on("resize", function () {
            onResizeWindow("tableLoaded");
        });
    }

    componentDidUpdate() {
        const { onResizeWindow } = this.props;
        if (!this.state.loading) {
            $("#loadTable").fadeIn(200);
            if ($(".light-border").outerHeight() && $(".rest-info").outerHeight()) {
                onResizeWindow("tableLoaded");
            }
        }
    }

    render() {
        const { receptionistsList, searchedPhrase, loading, displayNOR, showNOR, selectedColumns, noPermission } = this.state;
        const { onCheckUserPrivilage, loggedReceptionistID, onChangeNavAndPage, t } = this.props;

        //wyfiltrowana lista uczestników o wydarzenia, status wpłat i status uczestnika
        const filteredReceptionistList = receptionistsList;
        const currentPageParams = { nav: "receptionists", subpage: "receptionistsList", params: "" };
        return (
            <Fragment>
                {noPermission ? (
                    <NoPermission t={t} option="oneNavbar" />
                ) : (
                    <Fragment>
                        <Container fluid className="pt-2 second-bar">
                            <Row>
                                <Col lg={3} md={3} xs={12}>
                                    <Form.Label>{t("form.searching")}</Form.Label>
                                    <InputGroup className="mb-3">
                                        <Form.Control type="text" placeholder={t("form.search")} onChange={this.handleSearch} value={searchedPhrase} />
                                        {searchedPhrase && (
                                            <InputGroup.Append>
                                                <Button
                                                    variant="outline-primary"
                                                    onClick={() =>
                                                        this.setState({
                                                            searchedPhrase: "",
                                                            receptionistsList: this.state.originalReceptionists,
                                                        })
                                                    }
                                                >
                                                    <FontAwesomeIcon icon={faEraser} />
                                                </Button>
                                            </InputGroup.Append>
                                        )}
                                    </InputGroup>
                                </Col>
                                <Col xl={{ span: 1 }} lg={2} md={{ span: 2 }} xs={{ span: 3 }}>
                                    <RowsDropdown
                                        t={t}
                                        defaultValue={this.props.numberOfRecords}
                                        onChangeValue={(event, { value }) => {
                                            this.setState({
                                                showNOR: value,
                                                displayNOR: value,
                                            });
                                            this.props.onChangeNOR(value);
                                        }}
                                    />
                                </Col>

                                <Col
                                    xl={{ span: 3, offset: 5 }}
                                    lg={{ span: 3, offset: 4 }}
                                    md={{ span: 4, offset: 3 }}
                                    xs={{ span: 12, offset: 9 }}
                                    className="text-center text-lg-right mt-lg-3 mt-lg-0 mb-3"
                                >
                                    <Button variant="outline-primary" onClick={this.handleDownloadData} className="btn-sync mr-3">
                                        <FontAwesomeIcon icon={faSync} />
                                    </Button>
                                    {onCheckUserPrivilage("ACCR_ADD_RECEPTIONIST") && (
                                        <Button
                                            variant="outline-primary"
                                            type="button"
                                            onClick={() => onChangeNavAndPage({ nav: "receptionists", subpage: "addReceptionist", params: "" }, currentPageParams)}
                                        >
                                            {t("receptionist.addReceptionist")}
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </Container>
                        <Container fluid className="content-body">
                            {loading || !filteredReceptionistList ? (
                                <LoadingProgressBar t={t} />
                            ) : (
                                <div id="loadTable" style={{ display: "none" }}>
                                    <Row>
                                        <Col>
                                            <div className="table-responsive table-fixed-head">
                                                {filteredReceptionistList.length > 0 ? (
                                                    <Fragment>
                                                        <TableReceptionistsList
                                                            receptionists={receptionistsList}
                                                            numOfRecords={displayNOR}
                                                            loggedReceptionistID={loggedReceptionistID}
                                                            selectedColumns={selectedColumns}
                                                            onChangeNavAndPage={onChangeNavAndPage}
                                                            onCheckUserPrivilage={onCheckUserPrivilage}
                                                            t={t}
                                                        />
                                                        <div className="light-border"></div>
                                                    </Fragment>
                                                ) : (
                                                    <div className="text-center">{t("notFound")}</div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="rest-info py-3">
                                        <Col>
                                            {t("loaded")} {displayNOR > filteredReceptionistList.length ? filteredReceptionistList.length : displayNOR} {t("from")} {filteredReceptionistList.length}{" "}
                                            {t("records")}
                                        </Col>
                                        <Col className="text-center ">
                                            {displayNOR >= filteredReceptionistList.length ? (
                                                <p className="opacity-4">
                                                    <FontAwesomeIcon icon={faLongArrowAltRight} />
                                                    <span className="px-3">{t("thatsAll")}</span>
                                                    <FontAwesomeIcon icon={faLongArrowAltLeft} />
                                                </p>
                                            ) : (
                                                <Button onClick={() => this.setState({ displayNOR: showNOR + displayNOR })} variant="outline-primary">
                                                    {t("loadMore")}
                                                </Button>
                                            )}
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                </div>
                            )}
                        </Container>
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

export default ReceptionistsList;
